import {
  GetBroadcastKeyMessageGroups,
  GetPodcastKeyMessageGroups,
} from "@/data-access/discovery-view/queries/key-message-queries";
import { client } from "@/lib/urqlProvider";
import useDiscoveryKeyMessageStore from "./discovery-key-message.slice";

export const fetchBroadcastKeyMessageGroups = async (
  feedId: string,
): Promise<void> => {
  useDiscoveryKeyMessageStore.getState().setIsFetchingBroadcast(true);
  try {
    const result = await client
      .query(GetBroadcastKeyMessageGroups, { feedId })
      .toPromise();
    if (result.error) {
      throw new Error(result.error.message);
    }
    const groups = result.data?.broadcastKeyMessageGroups ?? [];
    useDiscoveryKeyMessageStore.getState().setBroadcastGroups(groups);
    useDiscoveryKeyMessageStore
      .getState()
      .setSelectedBroadcastKeyMessageIds([]);
    useDiscoveryKeyMessageStore.getState().setBroadcastGroupsError(null);
  } catch (error) {
    console.error("Failed to fetch broadcast key message groups", error);
    useDiscoveryKeyMessageStore.getState().setBroadcastGroups([]);
    useDiscoveryKeyMessageStore
      .getState()
      .setBroadcastGroupsError(
        error instanceof Error ? error.message : "Failed to load key topics",
      );
  } finally {
    useDiscoveryKeyMessageStore.getState().setIsFetchingBroadcast(false);
  }
};

export const fetchPodcastKeyMessageGroups = async (
  feedId: string,
): Promise<void> => {
  useDiscoveryKeyMessageStore.getState().setIsFetchingPodcast(true);
  try {
    const result = await client
      .query(GetPodcastKeyMessageGroups, { feedId })
      .toPromise();
    if (result.error) {
      throw new Error(result.error.message);
    }
    const groups = result.data?.podcastKeyMessageGroups ?? [];
    useDiscoveryKeyMessageStore.getState().setPodcastGroups(groups);
    useDiscoveryKeyMessageStore.getState().setSelectedPodcastKeyMessageIds([]);
    useDiscoveryKeyMessageStore.getState().setPodcastGroupsError(null);
  } catch (error) {
    console.error("Failed to fetch podcast key message groups", error);
    useDiscoveryKeyMessageStore.getState().setPodcastGroups([]);
    useDiscoveryKeyMessageStore
      .getState()
      .setPodcastGroupsError(
        error instanceof Error ? error.message : "Failed to load key topics",
      );
  } finally {
    useDiscoveryKeyMessageStore.getState().setIsFetchingPodcast(false);
  }
};
